









import Vue from "vue"
import ProgressCircular from "~/components/guideline/loading/ProgressCircular.vue"

export const emitEventWhenTouchBottom = "touch-bottom"

export default Vue.extend({
  components: {
    ProgressCircular,
  },
  props: {
    isFinished: {
      type: Boolean,
      required: true,
    },
    // スクロールイベントのターゲットはこのコンポーネント内にあるかを示すフラグ
    // trueの時にスクロールイベントのターゲットがこのコンポーネントを囲む<div>となる
    // falseの時にスクロールイベントのターゲットがwindowとなる
    isScrollTargetInside: {
      type: Boolean,
      default: false,
    },
    // スクロールイベントのターゲットの高さ
    // スクロールイベントのターゲットはこのコンポーネント内にある時のみ必要
    height: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      // このデータはisScrollTargetInside属性のコピーで、外側からは変えられない
      isInfiniteScrollListDivEventTarget: false,
    }
  },
  created() {
    this.isInfiniteScrollListDivEventTarget = this.isScrollTargetInside
  },
  mounted() {
    if (this.isInfiniteScrollListDivEventTarget) {
      this.setStyleForInfiniteScrollListDiv()
    }

    this.getScrollEventTarget().addEventListener("scroll", this.handleScroll)
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll)
  },
  methods: {
    // TODO : スタイル定義の場所を再検討
    setStyleForInfiniteScrollListDiv() {
      const infiniteScrollListElement: any = this.$refs.infiniteScrollList
      infiniteScrollListElement.style.cssText = `height: ${this.height}px; overflow-y: scroll; overflow-x: hidden;`
    },
    getScrollEventTarget(): any {
      return this.isInfiniteScrollListDivEventTarget
        ? this.$refs.infiniteScrollList
        : window
    },
    isWindowTouchBottom(): boolean {
      const infiniteScrollListElement: any = this.$refs.infiniteScrollList

      const offsetBottomOfPage = window.scrollY + window.innerHeight
      const extraSpace = 200
      const offsetBottomOfList =
        infiniteScrollListElement.clientHeight +
        infiniteScrollListElement.offsetTop

      return (
        !this.isInfiniteScrollListDivEventTarget &&
        offsetBottomOfPage + extraSpace > offsetBottomOfList
      )
    },
    isDivTouchBottom(): boolean {
      const infiniteScrollListElement: any = this.$refs.infiniteScrollList

      const scrollTop = infiniteScrollListElement.scrollTop
      const clientHeight = infiniteScrollListElement.clientHeight
      const extraSpace = 300
      const scrollHeight = infiniteScrollListElement.scrollHeight

      return (
        this.isInfiniteScrollListDivEventTarget &&
        scrollTop + clientHeight + extraSpace > scrollHeight
      )
    },
    handleScroll() {
      this.$emit("scroll")

      if (this.isFinished) {
        return
      }

      if (this.isDivTouchBottom() || this.isWindowTouchBottom()) {
        this.$emit("touch-bottom")
      }
    },
  },
})
